import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUserSlash, faUsers } from "@fortawesome/free-solid-svg-icons";

const LiveAgents = ({ live, offline, total }) => {
  //console.log(live, offline, total);
  return (
    <div className="bg-white rounded-xl p-4 w-full h-full flex flex-col shadow-md hover:shadow-lg transition-all duration-300">
      <h2
        style={{
          fontFamily: "Nunito Sans, sans-serif",
          fontSize: "24px",
          fontWeight: "bold",
          color: "#202224",
          marginBottom: "1rem",
        }}
      >
        Live Agents
      </h2>
      <div className="flex flex-col gap-4">
        {/* Total Agents */}
        <div className="flex items-center gap-2">
          <FontAwesomeIcon icon={faUsers} style={{ color: "#202224", fontSize: "16px" }} />
          <span
            style={{
              fontFamily: "Nunito Sans, sans-serif",
              fontSize: "16px",
              fontWeight: "600",
              color: "#202224",
            }}
          >
            Total: {total}
          </span>
        </div>
        {/* Live Agents */}
        <div className="flex items-center gap-2">
          <FontAwesomeIcon icon={faUser} style={{ color: "#FF6B00", fontSize: "24px" }} />
          <span
            style={{
              fontFamily: "Nunito Sans, sans-serif",
              fontSize: "24px",
              fontWeight: "bold",
              color: "#FF6B00",
            }}
          >
            {live}
          </span>
          <span className="live-dot"></span>
        </div>
        {/* Offline Agents */}
        <div className="flex items-center gap-2">
          <FontAwesomeIcon icon={faUserSlash} style={{ color: "#FFB877", fontSize: "24px" }} />
          <span
            style={{
              fontFamily: "Nunito Sans, sans-serif",
              fontSize: "24px",
              fontWeight: "bold",
              color: "#FFB877",
            }}
          >
            {offline}
          </span>
          <span className="offline-dot"></span>
        </div>
      </div>
      <style>
        {`
          .live-dot {
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #FF6B00;
            border-radius: 50%;
            animation: pulse 2s infinite ease-in-out;
          }

          .offline-dot {
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #FFB877;
            border-radius: 50%;
          }

          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 rgba(255, 107, 0, 0.7);
            }
            70% {
              box-shadow: 0 0 0 10px rgba(255, 107, 0, 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(255, 107, 0, 0);
            }
          }
        `}
      </style>
    </div>
  );
};

export default LiveAgents;